import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "children", "minWidth"];
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { toPx } from '../utils/Styles';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledToolBarGroup = styled.div.withConfig({
  displayName: "UIToolBarGroup__StyledToolBarGroup",
  componentId: "sc-7m4ngf-0"
})(["align-items:center;display:flex;flex-basis:", ";flex-grow:1;max-width:100%;white-space:nowrap;"], ({
  minWidth
}) => minWidth ? `${toPx(minWidth)} !important` : '0%');
export default class UIToolBarGroup extends PureComponent {
  render() {
    const _this$props = this.props,
      {
        className,
        children,
        minWidth
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const computedClassName = classNames("private-tool-bar__group has--horizontal-spacing", className);
    return /*#__PURE__*/_jsx(StyledToolBarGroup, Object.assign({}, rest, {
      minWidth: minWidth,
      className: computedClassName,
      children: children
    }));
  }
}
UIToolBarGroup.displayName = 'UIToolBarGroup';
UIToolBarGroup.propTypes = {
  children: PropTypes.node,
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};